import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { LabelActionsDropdownMenu } from './label-actions-dropdown-menu';
import messages from './messages';
import { TrackingNumber } from './tracking-number';
import LabelProviderLogo from '../../label-provider-logo/label-provider-logo';
import { VoidedMasLabelProviderLogo } from '../../label-provider-logo/voided-mas-label-provider-logo';

import style from './label-details.module.less';

const LabelDetails = ({
  actionMenuItems,
  carrierId,
  className,
  isMarkAsShipped = false,
  isVoided = false,
  labelProviderId,
  serviceName,
  trackingNumber,
  trackingUrl,
  fillProviderId,
}) => {
  const { formatMessage } = useIntl();

  const isEmptyLabelProviderLogo = !labelProviderId && !fillProviderId && !carrierId;
  const isVoidedEmptyLabelProviderLogo = isVoided && isEmptyLabelProviderLogo;

  return (
    <FlexRow className={classnames(style['label-details'], className)}>
      <FlexRow className={style['label-info']}>
        {isVoidedEmptyLabelProviderLogo ? (
          <VoidedMasLabelProviderLogo />
        ) : (
          <LabelProviderLogo
            carrierId={carrierId}
            fillProviderId={fillProviderId}
            isDisabled={isVoided}
            labelProviderId={labelProviderId}
          />
        )}
        <FlexColumn className={style['service-and-tracking-container']}>
          <Text
            aria-description={formatMessage(messages.serviceAriaDescription)}
            className={classnames(style['service-name'], {
              [style['is-voided']]: isVoided,
            })}
            textType={TextType.H3}
            value={isMarkAsShipped ? <FormattedMessage {...messages.markedAsShipped} /> : serviceName}
          />
          <TrackingNumber isVoided={isVoided} trackingNumber={trackingNumber} trackingUrl={trackingUrl} />
        </FlexColumn>
      </FlexRow>
      {actionMenuItems && <LabelActionsDropdownMenu actionMenuItems={actionMenuItems} />}
    </FlexRow>
  );
};

export default LabelDetails;

LabelDetails.propTypes = {
  className: PropTypes.string,
  labelProviderId: PropTypes.string,
  fillProviderId: PropTypes.string,
  serviceName: PropTypes.string,
  trackingUrl: PropTypes.string,
  trackingNumber: PropTypes.string,
  isVoided: PropTypes.bool,
  carrierId: PropTypes.string,
  isMarkAsShipped: PropTypes.bool,
  actionMenuItems: PropTypes.node,
};
